var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UiDatePicker',_vm._g(_vm._b({attrs:{"end-year":_vm.endYear}},'UiDatePicker',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }